import React, { useCallback } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import Organization from "@mapmycustomers/shared/types/Organization";
import { Button } from "@mapmycustomers/ui";

import { getOrganization } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

import billingAnalytics from "../../billingAnalytics";

import styles from "./Buttons.module.scss";

interface Props {
  checkoutEnabled: boolean;
  hideCheckout: boolean;
  onCheckoutClick?: () => void;
  organization: Organization;
}

const Buttons: React.FC<Props> = ({
  checkoutEnabled,
  hideCheckout,
  onCheckoutClick,
  organization,
}) => {
  const intl = useIntl();
  const handleTalkToSales = useCallback(() => billingAnalytics.clicked(["Talk To Sales"]), []);
  const handleUpdateCardInformation = () => window.profitwell("show_cc_form");

  return (
    <div className={styles.container}>
      <div>
        {organization.stripeId && (
          <Button onClick={handleUpdateCardInformation}>
            {intl.formatMessage({
              id: "billing.footer.updateCardInformation",
              defaultMessage: "Update Card Information",
              description: "Update Card Information button on Billing page",
            })}
          </Button>
        )}
      </div>
      <div className={styles.rightContainer}>
        <Button
          href="https://mapmycustomers.com/contact-sales/"
          onClick={handleTalkToSales}
          rel="noreferrer noopener"
          target="_blank"
          type={hideCheckout ? "primary" : "text"}
        >
          {intl.formatMessage({
            id: "billing.footer.talkToSales",
            defaultMessage: "Talk to Sales",
            description: "Talk to Sales button on Billing page",
          })}
        </Button>
        {!hideCheckout && (
          <Button disabled={!checkoutEnabled} onClick={onCheckoutClick} type="primary">
            {intl.formatMessage({
              id: "billing.footer.checkout",
              defaultMessage: "Proceed to Checkout",
              description: "Checkout button on Billing page",
            })}
          </Button>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  organization: getOrganization(state)!,
});

export default connect(mapStateToProps)(Buttons);
